import {
    GET_CAR_NO_LIST,
    GET_LOCATION,
    EDIT_CAR_NO
} from '../mutationTypes'
import {
    getCarNoBelongTo
} from '@/models/editOrderInfo'
import {
    setLocalConfig
} from '@/utils/storage'
// import { isUseTxMap } from '@/utils/ua'
import { Dialog } from 'vant'

// import Vue from 'vue'
// import { isWx } from '../../utils/ua'
// import { isWx } from '../../utils/ua'

const state = {
    location: {
        lng: '', // 经度
        lat: '' // 纬度
    },
    carNoBelongTo: {
        default_letter_id: '291', // 默认选中
        default: '粤(广东省)', // 默认省份归属地
        provs: null // 列表
    },
    user: {
        name: '', // 提货人
        car_no: '', // 车牌号，  提交订单时候，需要把车牌号提交到微养车，并生成一个默认爱车档案
        phone_number: '', // 手机号,
        letter_id: '', // 选中的车牌市区
        prov_name: '',
        prov_name_first: '',
        letter_name_first: ''
    }
}

const mutations = {
    [GET_LOCATION] (state, data) {
        state.location.lng = data.lng || ''
        state.location.lat = data.lat || ''
    },

    [GET_CAR_NO_LIST] (state, data) {
        state.carNoBelongTo.default = data.default
        // 记录在缓存
        state.carNoBelongTo.default_letter_id = data.default_letter_id
        state.carNoBelongTo.provs = data.provs
    },
    [EDIT_CAR_NO] (state, data) {
        let stateUser = state.user
        let user = {
            prov_name_first: data.prov_name_first || stateUser.prov_name_first,
            letter_name_first: data.letter_name_first || stateUser.letter_name_first,
            name: data.name || stateUser.name, // 提货人
            car_no: data.car_no || stateUser.car_no, // 车牌号，  提交订单时候，需要把车牌号提交到微养车，并生成一个默认爱车档案
            phone_number: data.phone_number || stateUser.phone_number, // 手机号,
            letter_id: data.letter_id || stateUser.letter_id, // 选中的车牌市区
            prov_name: data.prov_name || stateUser.prov_name // 选中的省份 ''
        }
        state.user = user
        setLocalConfig('icar_user', user)
    }
}

export const actions = {
    // 获取路径
    // 获取地理经纬度
    getLocation ({
        commit
    }, param = {}) {
        return new Promise((resolve, reject) => {
            const tip = () => {
                // https://lbs.amap.com/faq/js-api/map-js-api/position-related/43361
                Dialog.alert({
                    showCancelButton: true,
                    title: '提示',
                    message: '定位失败,请检查GPS是否已打开,点击确定自动刷新页面',
                }).then(() => {
                    console.log('reload')
                    location.reload()
                }).catch(() => {
                })
            }
            const fail = () => {
                param.from !== 'noTips' && tip()
                reject(new Error('授权失败'))
                commit(GET_LOCATION, {
                    lng: '',
                    lat: ''
                })
            }
            const options = { timeout: param.timeout || 5000, enableHighAccuracy: true }
            const positionOptions = {
                enableHighAccuracy: true, // 是否要求浏览器获取最佳效果，同浏览器定位接口参数。默认为false
                SDKLocation: true // 是否开启SDK辅助定位
            }
            let geolocation = new BMap.Geolocation() // eslint-disable-line
            geolocation.enableSDKLocation() // 开启SDK辅助定位
            // geolocation.disableSDKLocation()  // 关闭sdk辅助定位
            console.log('实例化地图')
            geolocation.getCurrentPosition(function (r) {
                console.log('定位数据', r)
                console.log('this.getStatus()', this.getStatus())
                // 常量描述
                // BMAP_STATUS_SUCCESS->检索成功。对应数值“0”
                // BMAP_STATUS_CITY_LIST->城市列表。对应数值“1”
                // BMAP_STATUS_UNKNOWN_LOCATION->位置结果未知。对应数值“2”
                // BMAP_STATUS_UNKNOWN_ROUTE->导航结果未知。对应数值“3”
                // BMAP_STATUS_INVALID_KE->非法密钥。对应数值“4”
                // BMAP_STATUS_INVALID_REQUES->非法请求。对应数值“5”
                // BMAP_STATUS_PERMISSION_DENIED->没有权限。对应数值“6”
                // BMAP_STATUS_SERVICE_UNAVAILABLE->服务不可用。对应数值“7”
                // BMAP_STATUS_TIMEOUT->超时。对应数值“8”
                // 备注 百度地图定位 用户拒绝或者允许获取地理位置，this.getStatus()都是0，都会走BMAP_STATUS_SUCCESS
                if (Number(this.getStatus()) === 0) { // eslint-disable-line
                    console.log('定位成功')
                    // if (r.accuracy == null) {
                    //     fail()
                    // } else {
                    //     // 用户允许地理位置授权
                    //     const position = r.point
                    //     commit(GET_LOCATION, {
                    //         lng: position.lng,
                    //         lat: position.lat
                    //     })
                    //     resolve(position)
                    // }
                    // 用户允许地理位置授权
                    const position = r.point
                    commit(GET_LOCATION, {
                        lng: position.lng,
                        lat: position.lat
                    })
                    resolve(position)
                } else {
                    // let err = this.getStatus()
                    // console.log(err)
                    fail()
                }
            }, options, positionOptions)
        })
    },
    // 逆向地理编码（根据经纬度获取详细地址）
    getAddress ({
        commit
    }, options = {}) {
        return new Promise((resolve, reject) => {
            // AMap.plugin('AMap.Geocoder', function () {
            //     var geocoder = new AMap.Geocoder({
            //         extensions: 'all'
            //     })
            //     geocoder.getAddress(options, function (status, result) {
            //         if (status === 'complete' && result.info === 'OK') {
            //             // result为对应的地理位置详细信息
            //             console.log(result.regeocode, 'result.regeocode')
            //             // resolve((result.regeocode))
            //         } else {
            //             reject(status)
            //         }
            //     })
            // })
            let myGeo = new BMap.Geocoder() // eslint-disable-line
            // 根据坐标得到地址描述
            myGeo.getLocation(new BMap.Point(options[0], options[1]), function (res) { // eslint-disable-line
                if (res) {
                    console.log(res, 'res')
                    resolve(res)
                } else {
                    reject(new Error('地址解析失败'))
                }
            })
        })
    },
    // 保存地址信息
    saveAddressInfo ({
        commit
    }, options = {}) {
        let obj = {
            longitude: options.longitude,
            latitude: options.latitude,
            province: options.province,
            city: options.city,
            district: options.district,
            name: options.name || options.formattedAddress || '',
            formattedAddress: options.formattedAddress
        }
        // longitude，latitude保存的是高德的经纬度，请求接口的时候需要转换成百度
        setLocalConfig('AddressInfo', obj)
    },
    // 获取车牌归属地
    async getCarNoBelongTo ({
        commit
    }, params) {
        const data = await getCarNoBelongTo(params)
        commit(GET_CAR_NO_LIST, data)
    },
    editLocationAddress ({
        commit
    }, data) {
        commit(EDIT_CAR_NO, data)
    }
}

export const getters = {
    carNoBelongTo (state) {
        return state.editOrderInfo.carNoBelongTo
    },
    user (state) {
        return state.editOrderInfo.user
    }
}

export default {
    state,
    mutations
}
